var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elType,{directives:[{name:"show",rawName:"v-show",value:(_vm.agendaItem.add_to_calendar_link),expression:"agendaItem.add_to_calendar_link"}],tag:"button",staticClass:"agenda__item-calendar-links-button",class:{
    'is-before-start' : _vm.isBeforeStart,
    'is-after-end' : _vm.isAfterEnd,
    'is-live' : _vm.isLive
  },on:{"click":_vm.clicked}},[_vm._t("text",function(){return [_c('i',{staticClass:"agenda__item-icon agenda__calendar-icon far fa-calendar-plus"}),_vm._v("\n    "+_vm._s(_vm.text || _vm.lang.get('event_strings.agenda.add_to_calendar'))+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }